export enum OntarioVehicleType {
  ladenSingleCommercialVehicle = 'ladenSingleCommercialVehicle',
  ladenTractorAndTrailer = 'ladenTractorAndTrailer',
  ladenUnladenTrailer = 'ladenUnladenTrailer',
  unladenCommercialVehicle = 'unladenCommercialVehicle',
}

export const OntarioVehicleTypeValues = Object.values(OntarioVehicleType);
